import React from "react";
import styled from "styled-components";
import useStatCardStyles from "./styles";

export type StatCardVariant = "orange" | "green" | "blue";

interface VfxStatCardProps {
  value: string | number;
  label: string;
  variant?: StatCardVariant;
  icon?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const StatCardWrapper = styled.div<{ $styles: any; $isClickable: boolean }>`
  ${(props) => props.$styles.card}
  cursor: ${(props) => (props.$isClickable ? "pointer" : "default")};

  ${(props) =>
    !props.$isClickable &&
    `
    &:hover {
      transform: none !important;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
    }
  `}
`;

export const StatCard: React.FC<VfxStatCardProps> = (props) => {
  const { value, label, variant, icon, className = "", style, onClick } = props;
  const statCardStyles = useStatCardStyles(variant);

  return (
    <StatCardWrapper
      $styles={statCardStyles}
      $isClickable={!!onClick}
      className={className}
      style={style}
      onClick={onClick}
    >
      <div style={statCardStyles.inner}>
        <div style={statCardStyles.content}>
          <h3 style={statCardStyles.value}>{value}</h3>
          <p style={statCardStyles.label}>{label}</p>
        </div>
        {icon && <div style={statCardStyles.iconWrapper}>{icon}</div>}
      </div>
    </StatCardWrapper>
  );
};
